import { Modal } from 'antd';

const { confirm } = Modal;

/**
 * This is a Modal to confirm/cancel an action
 * @param {string} title Modal's header
 * @param {string} content Modal's body
 * @param {function} action Callback to execute when user's answers is YES
 */
const ModalConfirm = (title, content, action) => {
  confirm({
    title,
    content,
    onOk() {
      action();
    },
    okText: 'Si, continuar',
    cancelText: 'No, cancelar',
  });
};

export default ModalConfirm;
